// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea-module__textarea__gw7Ey"};